// extracted by mini-css-extract-plugin
module.exports = {"root":"ob_umyhG8","root__footer":"ob_nOkot8","root__production":"ob_LANGe5","isBlur":"ob_w2hpAc"};